<div class="hpanel">
  <div class="jc-v3-tab-bar b-r-6" style="align-items:center;">
    <button type="button" class="jc-v3-tab-btn" [class.active]="id=='1'" (click)="activeTab('1')">Invites</button>
    <button type="button" class="jc-v3-tab-btn" [class.active]="id=='2'" (click)="activeTab('2')">Referral credits</button>
    <button type="button" title="Refresh" (click)="refershIvitesCount()"
            style="margin-left:8px;background:none;border:none;color:#6b7280;cursor:pointer;padding:0 12px;display:inline-flex;align-items:center;">
      <ng-icon name="tablerRefresh" aria-hidden="true"></ng-icon>
    </button>
  </div>

  <!-- <span style="float: right;" (click)="refershSugestedjob()"><ng-icon name="tablerRefresh" aria-hidden="true"></ng-icon></span> -->


  <div class="panel-body">
    <div class="tab-content" *ngIf="loadAPIcall">
      <div class="tab-pane" title="Invites" [ngClass]="{'active': id=='1'}" id={{id}}>
        <app-common-skeleton *ngIf="loadAPIcall" [countforView]="1"
          [NameOftheScreen]="'widgets'"></app-common-skeleton>
      </div>
      <div class="tab-pane" [ngClass]="{'active': id=='2'}" id={{id}}>
        <app-common-skeleton *ngIf="loadAPIcall" [countforView]="1"
          [NameOftheScreen]="'widgets'"></app-common-skeleton>
      </div>
    </div>
    <div *ngIf="!loadAPIcall"class="tab-content">
      <div class="tab-pane" title="Invites" [ngClass]="{'active': id=='1'}" id={{id}}>

        <div class=" table-responsive">
          <table class="table noborder">
            <!-- <thead>
              <tr>
                <th>Total Invites </th>
                <td>120</td>
              </tr>
            </thead> -->
            <tbody>
              <tr>
                <td>Total Invites </td>
                <td>{{invitesdata?.data?.totalCount}}</td>
              </tr>

              <tr>
                <td>Invites Accepted </td>
                <td>{{invitesdata?.data?.acceptedCount}}</td>
              </tr>

              <tr>
                <td>Pending Acceptance </td>
                <td>{{invitesdata?.data?.pendingCount}}</td>
              </tr>

              <tr>
                <td>Invites Cancelled </td>
                <td>{{invitesdata?.data?.cancelledCount}}</td>
              </tr>


            </tbody>
          </table>
        </div>

      </div>
      <div class="tab-pane" [ngClass]="{'active': id=='2'}" id={{id}}>

        <div class=" table-responsive">
          <table class="table noborder">

            <tbody>
              <tr>
                <td>Total Referral credits </td>
                <td>{{invitesdata?.data?.totalReferralPoints}}</td>
              </tr>

              <tr>
                <td>Redeemed  </td>
                <td>{{invitesdata?.data?.redeemedPoints}}</td>
              </tr>

              <tr>
                <td>Available to redeem  </td>
                <td>{{invitesdata?.data?.availableReferralPoints}}</td>
              </tr>




            </tbody>
          </table>
        </div>




      </div>
    </div>
  </div>
</div>
